import { Drawer } from "@xola/ui-kit";
import React, { ReactNode } from "react";

interface PreviewMessageTemplateDrawerProps {
    children: ReactNode;
    onClose: () => void;
    isOpen: boolean;
    classNames?: object;
}

export const PreviewMessageTemplateDrawer = ({
    children,
    onClose,
    isOpen,
    classNames,
}: PreviewMessageTemplateDrawerProps) => {
    return (
        <Drawer
            size="xl"
            isOpen={isOpen}
            content={children ?? <span />}
            classNames={classNames ?? { children: "!p-0", content: "mt-0" }}
            onClose={onClose}
        />
    );
};
